<template>
    <AbstractTheme color="#003399" :name="this.$options.name" :misc="misc" :show="show"/>
</template>

<script>
import AbstractTheme from './AbstractTheme'

export default {
  name: 'Blue',
  props: {
    misc: Object,
    show: Boolean,
  },
  components: { AbstractTheme },
}
</script>

<style lang="scss">
    //$color-primary: #003399;
    //@import '../../scss/helpers/variables';
    //@import '../../scss/explorer';
</style>



// WEBPACK FOOTER //
// src/components/theme/Blue.vue